/* eslint-disable @typescript-eslint/naming-convention */
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Spin, Result, Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import jwtDecode from "jwt-decode";
import {
  setAccessToken,
  setRefreshToken,
  setIDToken,
  setCurrentSubscriptionId,
  setIsSSOLogin,
  ssoCallback
} from "services/auth";

function SSOCallback() {
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const searchParams = new URLSearchParams(window.location.search);
        const code = searchParams.get("code");

        if (!code) {
          setError(
            "No authorization code received. Please try logging in again."
          );
          return;
        }

        try {
          const res: any = await ssoCallback({
            code
          });

          if (res?.status === 200 && res?.data.id_token) {
            const decodedIdToken: any = jwtDecode(res.data.id_token);

            setIDToken(res?.data.id_token);
            setAccessToken(res?.data.access_token);
            setRefreshToken(res?.data.refresh_token);
            setIsSSOLogin("true");

            if (decodedIdToken.associated_subscriptions.length === 1) {
              // single subscriptions
              setCurrentSubscriptionId(
                decodedIdToken.associated_subscriptions[0].id
              );
              history.replace("/projects");
            } else {
              history.replace("/subscription-select");
            }
          } else {
            history.replace("/");
          }
        } catch (error1: any) {
          console.error("Token exchange error:", error1);
          setError(
            error1?.message || "An error occurred during token exchange."
          );
          history.replace("/");
        }
      } catch (err: any) {
        setError(err?.message || "An error occurred during authentication.");
        history.replace("/");
      }
    };

    handleCallback();
  }, [history, location.search]);

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Result
          status="error"
          title="Authentication Failed"
          subTitle={error}
          extra={
            <Button type="primary" onClick={() => history.push("/")}>
              Back to Login
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen flex-col gap-4">
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
        size="large"
      />
      <p className="text-center text-gray-600">Completing your sign-in...</p>
    </div>
  );
}

export default SSOCallback;
